import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './layouts/footer/footer.component';
import { ThreeDotsBlinkingComponent } from './general/loading-states/three-dots-blinking/three-dots-blinking.component';
import { TranslocoRootModule } from '../transloco-root.module';

@NgModule({
  declarations: [FooterComponent, ThreeDotsBlinkingComponent],
  imports: [CommonModule, TranslocoRootModule],
  exports: [FooterComponent, ThreeDotsBlinkingComponent],
})
export class SharedComponentsModule {}
